"use client";

import Link from "next/link";
import {
  createCSSButtonStyle,
  createColorButtonStyle,
} from "../buttons/button.style";

type LinkButtonProps = {
  href: string;
  children: React.ReactNode;
  isReversedColor?: boolean;
  isNewTab?: boolean;
};

const LinkButton = ({
  href,
  children,
  isReversedColor,
  isNewTab,
}: LinkButtonProps) => {
  const style = createCSSButtonStyle();
  const cssProperties = createColorButtonStyle({ isReversedColor });

  return (
    <Link
      className={`${cssProperties} ${style}`}
      href={href}
      target={isNewTab ? "_blank" : "_self"}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
